<template>

   <w-tabs :items="tabs" :no-slider="false" active-class="primary" v-model="activeTab">
      <template #item-content.1>
         <w-card title-class="blue-dark4--bg white" style="font-size: 13px;"  :title="'MAKLUMAT TERNAKAN'" >
            <w-form ref="zform" v-model="valid" v-model:errors-count="errorsCount" @submit.prevent="validateForm" @success="success">
            <template #title>
                  MAKLUMAT TERNAKAN
                  <w-flex justify-end class="mt2">
                     <w-button @click="isMinimizedList = !isMinimizedList">
                        <template v-if="isMinimizedList">
                           <w-icon dark tile class="mr2">fal fa-angle-double-down</w-icon>
                        </template>
                        <template v-else>
                           <w-icon dark tile class="mr2">fal fa-angle-double-up</w-icon>
                        </template>
                     </w-button>
                  </w-flex>
               </template>
            <div v-show="!isMinimizedList">
             <div class="w-table-wrap" style="max-height: 400px;">
                <div class="table-profil-scrol">
                   <table class="w-table" color="light" >
                      <thead>
                         <tr>
                            <th class="w-table__header  text-center" width="1%">BIL</th>
                            <th class="w-table__header  text-center">NO KES </th>
                            <th class="w-table__header  text-center">NO PENDAFTARAN</th>
                            <th class="w-table__header  text-center">ID | NAMA TERNAKAN</th>
                            <th class="w-table__header  text-center">JENIS TERNAKAN</th>
                            <th class="w-table__header  text-center">JENIS PERKHIDMATAN </th>
                            <th class="w-table__header  text-center">NAMA PEMERIKSA </th>
                            <th class="w-table__header  text-center">KEPUTUSAN </th>
                            <!-- <template v-if="data.lkp_status_id==39"> -->
                               <th class="w-table__header  text-center">TINDAKAN</th>
                            <!-- </template> -->
                         </tr>
                      </thead>
                      <tbody>
                         <template v-for="(dt, ind) in data.ternakan_list">
                            <tr class="w-table__row" >
                               <td class="w-table__cell text-center" >{{ind+1}}</td>
                               <td class="w-table__cell text-center" >{{dt.no_kes}}</td>
                               <td class="w-table__cell text-center" >{{dt.id_ternakan}}</td>
                               <td class="w-table__cell text-center" style="text-transform: uppercase;">{{dt.id_ternakan_list}} | {{dt.nama_ternakan}}</td>
                               <td class="w-table__cell text-center" >{{dt.lkp_ternakan}}</td>
                               <td class="w-table__cell text-center" >{{dt.lkp_art}}</td>
                               <td class="w-table__cell text-center" >{{dt.user}}</td>
                               <td class="w-table__cell text-center" 
                                  :style="dt.hantar == 1 ? 
                                      (dt.keputusan.toLowerCase() === 'lulus' ? { backgroundColor: '#4CAF50', color: 'white' } : 
                                       dt.keputusan.toLowerCase() === 'gagal' ? { backgroundColor: '#F44336', color: 'white' } :
                                       dt.keputusan.toLowerCase() === 'lulus bersyarat' ? { backgroundColor: '#FFEB3B' } : {}) : {}">
                                  {{ dt.keputusan }}
                              </td>
                               <td class="w-table__cell text-center" width="15%" >
                                   <w-tooltip top color="white" bg-color="black" v-if=" dt.hantar == 1" >
                                      <template #activator="{ on }">
                                       <w-button  bg-color="primary" v-on="on" :route="$route('art.semakan.penilaian.fe_show',dt.id)" class="be fs-2"><div style="width: 8px"></div>
                                         <w-icon md class="mr2">fal fa-eye</w-icon>
                                         </w-button>
                                       </template>
                                       Papar
                                     </w-tooltip>
                                     <w-tooltip top color="white" bg-color="black" v-else-if=" $zutil.anyRole(['4'])" >
                                      <template #activator="{ on }">
                                       <template v-if = "data.lkp_status_id != 31 && data.lkp_status_id != 21 ">
                                         <w-button bg-color="warning" v-on="on" :route="$route('art.semakan.penilaian.fe.form',dt.id)" class="be fs-2"><div style="width: 8px"></div>
                                         <w-icon md class="mr2">fal fa-pencil</w-icon>
                                         </w-button>
                                      </template>
                                       </template>
                                       Kemaskini
                                     </w-tooltip>
                                     &nbsp;
                                   <w-tooltip md top align-right color="white" bg-color="black">
                                      <template #activator="{ on }">
                                         <!-- <inertia-link :href="$route('pdbf.penilaian.sejarah', dt.ternakan_id)" v-on="on" class="w-button w-button--dark size--md info-dark1--bg"> <div style="width: 8px"></div>
                                           <w-icon md class="mr2">fal fa-history</w-icon>
                                         </inertia-link> -->
                                         <inertia-link :href="$route('art.semakan.penilaian.fe.sejarah', dt.ternakan_id)" v-on="on" class="w-button w-button--dark size--md info-dark1--bg"> <div style="width: 8px"></div>
                                           <w-icon md class="mr2">fal fa-history</w-icon>
                                         </inertia-link>
                                       </template>
                                       Sejarah
                                     </w-tooltip>
                               </td>
                            </tr>
                         </template>
                      </tbody>
                   </table>
                </div>
             </div>
             </div>
            <w-flex class="mt3" wrap align-center justify-end v-if="data.lkp_status_id==39">
               <w-button class="my1" type="submit" :disabled="loading" :loading="loading">
                   <w-icon xs class="mr2">fal fa-paper-plane</w-icon> Mohon Semula Pemeriksaan Fertiliti
               </w-button>
            </w-flex>
            </w-form>
         </w-card>
         <br>
         
         <br>
      </template>

      <template #item-content.2 >
         <CajPerkhidmatanShow :d_data="data" :d_segmenName="segmenName" v-if="data.id > 0"/>
      </template>
      <template #item-content.3>
         <w-card title-class="blue-dark4--bg white" style="font-size: 13px;"  :title="'AUDIT TRAIL'" >
            <div class="w-table-wrap" style="max-height: 400px;">
               <div class="table-profil-scrol">
                  <table class="w-table" color="light" >
                     <thead>
                        <tr>
                          <th class="w-table__header  text-center" width="1%">BIL</th>
                          <th class="w-table__header  text-center">USER</th>
                          <th class="w-table__header  text-center">STATUS</th>
                          <th class="w-table__header  text-center">REMARK</th>
                          <th class="w-table__header  text-center">TARIKH</th>
                        </tr>
                     </thead>
                     <tbody>
                        <template v-for="(data, ind) in data.audit_trail">
                        <tr class="w-table__row" >
                            <td class="w-table__cell text-center" >{{ind+1}}</td>
                            <td class="w-table__cell text-center" >{{data.user}}</td>
                            <td class="w-table__cell text-center" >{{data.status}}</td>
                            <td class="w-table__cell text-center" >{{data.remark}}</td>
                            <td class="w-table__cell text-center" >{{data.tarikh}}</td>
                           </tr>
                        </template>
                     </tbody>
                  </table>
               </div>
            </div>
         </w-card>
      </template>
   </w-tabs>

   <w-dialog
      v-model="dialogSemak.show"
      :fullscreen="dialogSemak.fullscreen"
      :width="dialogSemak.width"
      :persistent="dialogSemak.persistent"
      :persistent-no-animation="dialogSemak.persistentNoAnimation"
      title-class="primary-dark1--bg white">
      <template #title>
         <w-icon class="mr2">fal fa-list</w-icon>
         Semak Semula Perkhidmatan
      </template>
      <br>{{dialogSemak.form}}
      <w-form
         ref="form"
         v-model="dialogSemak.valid"
         @validate="sahkan(27)"
         @success="success"
       >
      <div class="w-flex wrap smd-column" >
          <w-textarea style="margin:5px;" label="Catatan *"  placeholder="Sila masukan.." class="mt4" outline  v-model="dialogSemak.item.catatan" :validators="[validators.required]"/>
      </div>
      </w-form>
      <template #actions>
         <div class="spacer" />
         <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialogSemak.show = false">TUTUP</w-button>
         &nbsp;
         <w-button class="mr2" :loading="dialogSemak.loading" :disabled="dialogSemak.loading || dialogSemak.item.catatan == null" @click="sahkan(27)">
            <w-icon m class="mr2">fal fa-paper-plane</w-icon>Hantar
         </w-button>
      </template>
   </w-dialog>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'
import VueQrcode from 'vue-qrcode'
import ButiranKelahiran from './Sub/ButiranKelahiran.vue'
import CajPerkhidmatanShow from './Sub/CajPerkhidmatanShow.vue'

export default {
extends: ZResource,
components: {
VueQrcode, ButiranKelahiran, CajPerkhidmatanShow
},
props: {
d_id: [Array, Object, String],

},
data() {
return {
resourceurl: 'art.permohonan',
crumbs: [
  { label: this.$page.props.app_name, route: '/home' },
  { label: 'Pembiakan Permohonan', route: '/art' },
  { label: 'Permohonan', route: '/art/permohonan' },
  { label: 'Papar', route: '/art/permohonan/'+this.id },
],

title : '',
id:this.d_id,
data : {id : 0},
activeTab : 0,
activeTabModal : 0,
ada_bunting: 0,
ternakan_list:[],
tabs: [
      { title: 'RUMUSAN PERKHIDMATAN', content: '' },
      { title: 'CAJ PERKHIDMATAN', content: '' },
      // { title: 'AUDIT TRAIL', content: '', disabled:false},
],
tabsModal: [
      { title: 'MAKLUMAT PEMERIKSAAN TERNAKAN', content: '' },
      { title: 'MAKLUMAT PROSEDUR Pemeriksaan Fertiliti', content: ''},
      { title: 'MAKLUMAT PEMERIKSAAN BUNTINGAN Pemeriksaan Fertiliti', content: ''},
],
ibvk: [],
negri: [],
persendirian: [],
isMinimizedList: false,
isMinimizedCajAi: false,
isMinimizedCajKeb: false,
dialog: {
    valid: false,
    show: false,
    fullscreen: false,
    persistent: true,
    persistentNoAnimation: false,
    loading: false,
    width: 1500,
    tab: 0,
    item: []
  },
dialogPd: {
    valid: false,
    show: false,
    fullscreen: false,
    persistent: true,
    persistentNoAnimation: false,
    loading: false,
    width: 900,
    item: []
  },
dialogSemak: {
   valid: false,
   show: false,
   fullscreen: false,
   persistent: true,
   persistentNoAnimation: false,
   loading: false,
   width: 900,
   item: {
      catatan:null
   }
},
juruteknik_list: [],
lkp_tujuan:[],
form_pd:{
   art_id: 0,
   lkp_tujuan_id: null,
   juruteknik_pd_id: 0,
   jankaan_biang_semula: null,
   tarikh_datang_pemeriksaan: null,
},
jankaan_biang_semula:null,
}
},
methods: {
semaksemula(){
   this.dialogSemak.show = true;
},
validateForm() {
   this.loading=true;
   let isValid = true;
   let jumlah_lulus = 0;
   this.data.ternakan_list.forEach((row) => {
      if (row.pilih == true) {
         jumlah_lulus = 1;
      }
   })

   if (jumlah_lulus == 0) {
     this.$zutil.notify("Pastikan data sudah di Pilih", false);
     this.loading=false;
     return false;
   }

   this.MohonSemula()
},

MohonSemula(){
   this.$swal({
       title: 'Anda Pasti?',
       // text: "Are you sure want to delete this item!",
       type: 'warning',
       showCancelButton: true,
       confirmButtonColor: '#3085d6',
       cancelButtonColor: '#d33',
       confirmButtonText: 'Ya',
       cancelButtonText: 'Tidak'
      }).then((result) => {
      if (result.value) {
         if(this.data.id > 0){
         this.$zcomm.update('art.semakan.mohonSemulaAi', this.data.id, this.data)
           .then(res => {
               this.$inertia.visit(window.route('art.permohonan.ferteliti',0)+'?salin='+this.data.id);
               this.loading = false;
           })
           .catch(err => {

           })
           .finally(() => {

           });
       }
     }else{ this.loading = false;}

     })
},
mohonPd(dt, tab){
   this.form_pd.art_id = this.data.id;
   this.form_pd.lkp_tujuan_id = 5;
   this.form_pd.jankaan_biang_semula = this.jankaan_biang_semula ;
   this.form_pd.tarikh_datang_pemeriksaan = null;
   this.dialogPd.show = true;
   this.getJuruteknik();
   this.getTujuanPd();
},
getJuruteknik(data){
   this.$zcomm.get(this.api_service + 'lookup/juruteknik/'+this.data.lkp_negeri_id+'/2'+'/0', {}).then(res => {
      this.juruteknik_list = res
   });
},
getTujuanPd(){
   this.$zcomm.get(this.api_service + 'lookup/tujuan', {}).then(res => {
     this.lkp_tujuan = res
   })
},

detail(datas, tab){
   this.dialog.item = datas;
   this.dialog.tab = tab ? tab : 0;
   this.dialog.show = true;
},
tutup(){
   this.$inertia.visit(window.route('art.semakan.index'));
 },

cetak(data){
  // this.$inertia.visit(route("kursus.kursus.peserta.sijil_peserta", dt.peseta_user_id) +"?kursus_id="+dt.id,);
  window.open( window.route('art.permohonan.cetak', data), '_blank');
},

sahkan(item) {
   if (item == 27) {
      let isValid = true;
      this.dialogSemak.loading=true;
      if (!this.dialogSemak.item.catatan) {
        isValid = false;
        this.dialogSemak.loading=false;
      }
      if (!isValid)
      {
        this.$zutil.notify("Catatan Wajib diisi", false);
        this.dialogSemak.loading=false;
        return false;
      }
      this.data.semakan_catatan = this.dialogSemak.item.catatan;
   }
  this.loading = true;
  this.$swal({
    title: 'Anda Pasti?',
    // text: "Are you sure want to delete this item!",
    type: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Ya',
    cancelButtonText: 'Tidak'
  }).then((result) => {
  if (result.value) {
    if(this.data.id > 0){
      this.data.lkp_status_id = item;
      this.data.peternak = 1;
    this.$zcomm.update('art.semakan.bse-aiman.update', this.data.id, this.data)
        .then(res => {
            this.dialog.show = false;
            this.$inertia.visit(window.route('art.semakan.index'));
        })
        .catch(err => {

        })
        .finally(() => {
        });
        this.dialog.loading = false;
    }
  }else{ this.loading = false;
         this.dialogSemak.loading=false;
      }

  })
},

cekKebuntingan(){
   this.ada_bunting = 0;
   for (var b in this.data.ternakan_list) {
         if(this.data.ternakan_list[b].bunting == 1 || this.data.ternakan_list[b].bunting_art == 1){
            this.ada_bunting = 1;
            break;
         }else{
            this.ada_bunting = 0;
        }
   }
},

getData()
{
this.$zcomm.get(this.api_service + 'art/show/'+this.id, {}).then(res => {
  this.data = res

   
  // if (this.data) {}
// if(this.$zutil.role('1')){
//     this.tabs = [
//       // { title: 'Baka', content: '' },
//       { title: 'Ternakan', content: '' },

//     ]
//   }
//   else
//   {
//     this.tabs = [
//       { title: 'Ternakan', content: '' },

//     ]
//   }
   // if(this.data.lkp_status_id==40||this.data.lkp_status_id==18){
   //    this.tabs[1].disabled = false;
   // }else{
   //    this.tabs[1].disabled = true;
   // }
 if(this.data.lkp_art_id == 1)
  {
    this.title = 'RUMUSAN PERKHIDMATAN AI'
  }
  if(this.data.lkp_art_id == 2)
  {
    this.title = 'RUMUSAN PEMERIKSAAN KEBUNTINGAN'
  }
  if(this.data.lkp_art_id == 3)
  {
    this.title = 'RUMUSAN PERKHIDMATAN ET'
  }
  this.params = location.search.slice(1).split('&').map(p => p.split('=')).reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
  
  // Tukar 't' kepada 'tab' supaya sepadan dengan URL ?tab=2
  if(this.params.tab == 2){
    this.activeTab = 1 // Index 1 adalah tab "CAJ PERKHIDMATAN"
  } else {
    this.activeTab = 0 // Defaultkan balik ke tab pertama jika tiada parameter
  }

})
},




},
watch: {

},
mounted() {
this.getData();



},
}
</script>

<style>
.table-aims td{
padding: 7px;
}
</style>

